import templateReducer from "./reducers/templateReducer";

const rootReducers = {
    template: templateReducer 
}
export default rootReducers;